const API_BASE_URL = "/wp-json/cn-wp-api/v1";

export const API_CAUSES_LISTS_URL = `${API_BASE_URL}/discover-charities/lists`;
export const API_CAUSES_FUNDS_URL = `${API_BASE_URL}/discover-charities/funds`;

export const API_WP_IMAGES_URL = `${API_BASE_URL}/wp/images`;
export const API_WP_PAGES_URL = `${API_BASE_URL}/wp/pages`;
export const API_WP_POSTS_URL = `${API_BASE_URL}/wp/posts`;

export const API_ADOBE_HEADER_URL = `${API_BASE_URL}/adobe/header`;
export const API_ADOBE_FOOTER_URL = `${API_BASE_URL}/adobe/footer`;

export const API_PEOPLE_PROFILES_URL = `${API_BASE_URL}/people/profiles`;
export const API_PEOPLE_CATEGORIES_URL = `${API_BASE_URL}/people/categories`;
